// Phase E2 SaveAdapter — fetch wrappers around three projector routes.
// All requests assume the projector is reachable at the supplied
// baseUrl (typically apps/web's VITE_PROJECTOR_URL).

import type { DiffResult, PublishResult, SaveAdapter } from './types';

export class FsGitAdapter implements SaveAdapter {
  constructor(private baseUrl: string) {}

  private async expectOk(res: Response, op: string): Promise<void> {
    if (!res.ok) {
      const body = await res.text().catch(() => '');
      throw new Error(`${op} failed: ${res.status} ${body}`);
    }
  }

  async save(path: string, content: string): Promise<void> {
    const res = await fetch(`${this.baseUrl}/studio/save`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ path, content }),
    });
    await this.expectOk(res, 'save');
  }

  async diff(path: string): Promise<DiffResult> {
    const res = await fetch(
      `${this.baseUrl}/studio/diff?path=${encodeURIComponent(path)}`,
      { method: 'GET' },
    );
    await this.expectOk(res, 'diff');
    return (await res.json()) as DiffResult;
  }

  async publish(paths: string[], message: string): Promise<PublishResult> {
    const res = await fetch(`${this.baseUrl}/studio/publish`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ paths, message }),
    });
    await this.expectOk(res, 'publish');
    return (await res.json()) as PublishResult;
  }
}
